// extracted by mini-css-extract-plugin
module.exports = {"shadow":"GridHeaderButton_shadow__2YLQh","gridHeaderButton":"GridHeaderButton_gridHeaderButton__1vdzw","relative":"GridHeaderButton_relative__3s_EE"};